import { registerComponent } from '@gig/magic-common';
import PeriodicAccountReviewComponent from './periodic-account-review.vue.js';

var PeriodicAccountReview = registerComponent(PeriodicAccountReviewComponent);

export { PeriodicAccountReview };
